<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 415 257"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M49.1463 256.662H281.593C296.009 256.662 305.071 240.356 298.116 228.092L181.705 24.6949C162.174 -8.67808 111.771 -7.50909 94.5842 27.533L6.14884 181.736C-11.6757 213.578 11.2572 256.662 49.1463 256.662Z"
            fill="#0043FF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M232.398 75.0248C218.692 51.1848 226.765 20.5332 250.611 6.72111C274.269 -7.09096 304.686 1.04506 318.393 25.0743L408.33 181.927C422.036 205.767 413.963 236.418 390.117 250.23C366.459 264.042 336.042 255.906 322.336 231.877L232.398 75.0248Z"
            fill="#0043FF"
        />
    </svg>
</template>
